import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import SiMaxPrice from '~/Api/User/ProductGroup/SiMaxPrice/SiMaxPrice';
import { formatPercentage } from '~/utils/Intl';
import { selectComparativeDataSources, selectSlovenianExFactoryPrice } from '~/SiMaxPrice/reducer';
import { ApplicationState } from '~/Store';

import Calculation from './Calculation';

const memoizedSelectComparativeDataSources = memoizeOne(selectComparativeDataSources);
const memoizedSelectSlovenianExFactoryPrice = memoizeOne(selectSlovenianExFactoryPrice);

interface OwnProps {
	siMaxPrice: SiMaxPrice;
}

function mapStateToProps(state: ApplicationState, props: OwnProps) {
	const { siMaxPrice } = props;
	return {
		dataSources: memoizedSelectComparativeDataSources(siMaxPrice),
		czechExFactoryPrice: memoizedSelectSlovenianExFactoryPrice(siMaxPrice),
		formatPercentage,
	};
}

export default connect(mapStateToProps)(Calculation);
